__turbopack_context__.v({
  "container": "LicenseFinder-module-scss-module__oarOYq__container",
  "contentCard": "LicenseFinder-module-scss-module__oarOYq__contentCard",
  "contentTitle": "LicenseFinder-module-scss-module__oarOYq__contentTitle",
  "groupContent": "LicenseFinder-module-scss-module__oarOYq__groupContent",
  "root": "LicenseFinder-module-scss-module__oarOYq__root",
  "tabNav": "LicenseFinder-module-scss-module__oarOYq__tabNav",
  "tabPanel": "LicenseFinder-module-scss-module__oarOYq__tabPanel",
});
